import * as fromDatatype from '../datatype-library/index';

export interface app_ui_mst_panel_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  panel_type: fromDatatype.VarcharDatatypeInterface;
  profile_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_ui_mst_panel_RowClass
  implements app_ui_mst_panel_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  panel_type: fromDatatype.VarcharDatatypeInterface;
  profile_guid: fromDatatype.GuidDataFieldInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
